import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';
import { sizes, colors } from '../../styles/vars';

const Wrapper = styled.div`
  display: flex;
  position: relative;
  width: ${sizes.pageWidth};
  min-width: ${sizes.pageMinWidth};
  margin: 0 auto;

  button {
    cursor: pointer;
    outline: none;
  }

  textarea {
    resize: none;
    outline: none;
    font-size: 14px;
    color: ${colors['warm-grey-two']};
  }

  .mediaBlockContent {
    box-shadow: 0 2px 8px 0 ${COLORS.black};
  }

  .videoFrame {
    width: 100%;
    border: 0;
    height: 286px;
    margin: 20px 0 30px;
  }
`;

export default Wrapper;
